export default __webpack_public_path__ + "static/lr-de905735a81b8bffc88662bc548e653d.svg";